// src/index.js

import React from "react";
import ReactDOM from "react-dom";
import "./index.scss";
import App from "./App";
import "./i18n";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import { persistor, store } from "./store/store";
import { PersistGate } from "redux-persist/integration/react";

// Clickjacking Protection - Frame Busting
if (window.self !== window.top) {
  // The page is in an iframe - prevent it
  window.top.location = window.self.location;
  console.error('Clickjacking attempt detected and blocked!');
}

ReactDOM.render(
  <Provider store={store}>
    <PersistGate persistor={persistor}>
      <App />
    </PersistGate>
  </Provider>,
  document.getElementById("root")
);

reportWebVitals();
